(function () {
    'use strict';

    angular
        .module('app')
        .controller('TanksLinkedController', TanksLinkedController);

    TanksLinkedController.$inject = [
        '$scope',
        '$rootScope',
        '$route',
        '$routeParams',
        '$location',
        '$timeout',
        '$filter',
        '$translate',
        'blockUI',
        '$uibModal',
        'CustomerService',
        'SelectService',
        'NotifyService',
        'ExportService',
        'TanksService',
        'EmbeddedService'
    ];

    function TanksLinkedController(
        $scope,
        $rootScope,
        $route,
        $routeParams,
        $location,
        $timeout,
        $filter,
        $translate,
        blockUI,
        $uibModal,
        CustomerService,
        SelectService,
        NotifyService,
        ExportService,
        TanksService,
        EmbeddedService
    ) {

        $scope.getFiltersList = SelectService.getLPRList;

        $scope.data = {
            ownerTypes: [
                {id: 'all', title: 'All'},
                {id: 'customer', title: 'owner_type#customer'},
                {id: 'corporate-customer', title: 'owner_type#corporate-customer'},
            ],
            active: [
                {id: 'all', title: 'All'},
                {id: 'yes', title: 'Yes'},
                {id: 'no', title: 'No'},
            ]
        };

        $scope.customersTableColsPreset = [
            {
                visible: true,
                data: [
                    {value: 'name', text: 'Customer name', visible: true},
                    {value: 'phone', text: 'Customer number', visible: true},
                    {value: 'email', text: 'Email', visible: true}
                ]
            },
            {
                visible: true,
                data: [
                    {
                        value: 'type',
                        text: 'Owner type',
                        visible: true
                    },
                ]
            }
        ];

        $scope.tanksTableColsPreset = [
            {
                visible: true,
                data: [
                    {
                        value: 'title',
                        text: 'Tank title',
                        visible: true
                    },
                    {
                        value: 'product_title',
                        text: 'Tank product title ',
                        visible: true
                    }
                ]
            },
            {
                visible: true,
                data: [
                    {
                        value: 'product_volume',
                        text: 'Tank product volume',
                        visible: true
                    },
                    {
                        value: 'ullage_volume',
                        text: 'Tank ullage_volume',
                        visible: true
                    },
                    {
                        value: 'volume',
                        text: 'Tank volume',
                        visible: true
                    }
                ]
            },
            {
                visible: true,
                data: [
                    {
                        value: 'code',
                        text: 'Tank code',
                        visible: true
                    }
                ]
            },
        ];

        $scope.getFiltersList = SelectService.getLPRList;
        $scope.getPages = getTotalPaginatedPages;


        $scope.tanksLinked = [];
        $scope.tanksLinkedSummary = undefined;
        $scope.params = {
            page: 1,
            count: 20,
            owner_type: 'all',
            active: 'all',
        }

        $scope.customerParams = {
            customer_type: 'all',
            page: 1,
            count: 20,
        };

        $scope.customers = {};

        $scope.customerTanks = [];

        $scope.filterHelper = {};

        $scope.table_cols = [
            {
                visible: true,
                data: [
                    {
                        value: 'title',
                        text: 'Tank title',
                        visible: true,
                        sorting: 'title'
                    },
                    {
                        value: 'goods_code',
                        text: 'Tank linked goods code',
                        visible: true
                    },
                    {
                        value: 'volume',
                        text: 'Tank volume',
                        visible: true
                    },
                    {
                        value: 'product_volume',
                        text: 'Tank product volume',
                        visible: true
                    },
                    {
                        value: 'ullage_volume',
                        text: 'Tank filled volume',
                        visible: true
                    }
                ]
            },
            {
                visible: true,
                data: [
                    {
                        value: 'owner_name',
                        text: 'Owner name',
                        visible: true
                    }, {
                        value: 'owner_phone',
                        text: 'Owner phone',
                        visible: true
                    }, {
                        value: 'owner_email',
                        text: 'Owner email',
                        visible: true
                    }, {
                        value: 'owner_type',
                        text: 'Owner type',
                        visible: true
                    }, {
                        value: 'owner_external_id',
                        text: 'External id',
                        visible: true
                    },
                ]
            },
            {
                visible: true,
                data: [
                    {
                        value: 'address',
                        text: 'Tank address',
                        visible: true
                    },
                    {
                        value: 'product_title',
                        text: 'Tank product title',
                        visible: true
                    },
                    {
                        value: 'code',
                        text: 'Tanks linked code',
                        visible: true
                    },

                ]
            },
            {
                visible: true,
                data: [
                    {
                        value: 'active',
                        text: 'Tanks linked active',
                        visible: true,
                        sorting: 'active'
                    }
                ]
            }
        ];


        var block_tanks_linked_list = blockUI.instances.get('tanks-linked-list'),
            block_tanks_list = blockUI.instances.get('tanks-list');

        $scope.searchCustomerField = {
            // searchCustomer: {},
            searchText: '',
            onCustomerFieldSelect: function ($item) {
                $scope.searchCustomerField.searchCustomer = $item;
                delete $scope.searchCustomerField.searchText;
            },
            getSearchCustomers: function (val) {
                return new Promise(function (resolve) {
                    var params = {
                        search_text: val,
                        customer_type: $scope.params.owner_type,
                        page: 1,
                        count: 5
                    }
                    CustomerService.AllTypeCustomers(params, function (success, data) {
                        if (success) {
                            resolve(data.data);
                        }
                    });
                })
            }
        };

        initController();

        function initPageMode() {
            $scope._pageMode = 'show';

            if (isRouteMode('create')) {
                $scope._pageMode = 'create';
            }

        }

        function initController() {
            initPageMode();

            switch ($scope._pageMode) {
                case 'create':
                    doCreate();
                    break;

                case 'show':
                    doShow();
                    break;

                case 'edit':
                    doEdit();
                    break;
            }
        }

        $scope.onSelectGoodsCodeFilter = function (item) {
            if (typeof item === 'string') {
                $scope.params.goods_code = {
                    code: item
                }
            }
        }

        function doShow() {
            getTanksLinked();
            EmbeddedService.GetGoods({
                service_type: 'fuel'
            },function (success, data) {
                if (success) {
                    $scope.data.goodsList = angular.copy(data);
                }
            });
        }

        function doCreate() {
            $scope.params.owner_type = 'customer';
            var customerId = $routeParams['customerId'];
            $scope.customerParams.search_text = $routeParams['phone'] || $routeParams['email'];

            getCustomers(customerId);
            if (customerId) {
                getCustomerTanks(customerId);
            }
        }

        function doEdit() {
        }

        $scope.getTanksLinked = getTanksLinked;

        function getTanksLinked(callback) {
            if (!block_tanks_linked_list.isBlocking()) {
                block_tanks_linked_list.start();
            }

            var params = angular.copy($scope.params);
            if (params.owner_type && params.owner_type === 'all') {
                delete params.owner_type;
            }

            if (params.goods_code) {
                params.goods_code = params.goods_code.code;
            }
            if ($scope.searchCustomerField.searchCustomer) {
                params.owner_type = $scope.searchCustomerField.searchCustomer.type;
                params.owner_id = $scope.searchCustomerField.searchCustomer.id;
            }

            TanksService.GetTanksLinked(params, function (success, data) {
                if (success) {
                    $scope.tanksLinked = angular.copy(data.data);
                    $scope.tanksLinkedSummary = angular.copy(data.summary);
                }

                block_tanks_linked_list.stop();
                if (typeof callback === 'function') {
                    callback();
                }
            });
        }

        $scope.isPageMode = isPageMode;

        function isPageMode(mode) {
            return mode === $scope._pageMode;
        }

        function isRouteMode(mode) {
            return $routeParams && $routeParams.hasOwnProperty('mode') && $routeParams.mode === mode;
        }

        $scope.deleteTankLinked = function (tankLinked) {
            block_tanks_linked_list.start();
            TanksService.DeleteTankLinked(tankLinked.id, function () {
                getTanksLinked();
            })
        }
        $scope.onShowQR = function (tankLinked) {
            console.log('tankLinked', tankLinked)
            $uibModal.open({
                animation: true,
                keyboard: true,
                size: 'md',
                templateUrl: 'app/pages/tanks-linked/modals/qr-code.modal.html',
                controllerAs: 'popup',
                controller: function ($uibModalInstance) {
                    var popup = this;
                    popup.tankLinked = tankLinked;


                    popup.onPrint = function () {
                        var printContents = document.getElementById('printable-qr').innerHTML,
                            canvas_qr_dataurl = document.getElementsByTagName('canvas')[0].toDataURL(),
                            canvas_string = '<canvas class="qrcode" height="512" width="512"></canvas>',
                            popupWin = window.open('', '_blank', 'screenX=1,screenY=1,left=1,top=1,' + 'width=' + screen.availWidth + ',height=' + screen.availHeight);

                        printContents = printContents.replace(canvas_string, '<img src="' + canvas_qr_dataurl + '">');

                        popupWin.document.open();
                        popupWin.document.write('<html><head><base href="/"><title></title>' +
                            '<link href="assets/print/print_qr.min.css" rel="stylesheet"/></head>' +
                            '<body>' + printContents + '</body></html>');
                        popupWin.focus();
                        // setTimeout(function () {
                        //     popupWin.document.execCommand('print');
                        //     popupWin.print();
                        //     popupWin.document.close();
                        //     popupWin.close();
                        // }, 10);
                        var count = popupWin.document.querySelectorAll('img, link').length;

                        function printOnLoad() {
                            setTimeout(function () {
                                popupWin.focus();
                                popupWin.document.execCommand('print');
                                // popupWin.print();
                                popupWin.document.close();
                                popupWin.close();
                            }, 200);
                        }

                        if (count) {
                            popupWin.document.querySelectorAll('img, link').forEach(function (el) {
                                el.onload = function () {
                                    if (!--count) {
                                        printOnLoad()
                                    }
                                };
                            });
                        } else {
                            printOnLoad()
                        }
                    }

                    popup.onCancelClick = function () {
                        $uibModalInstance.close();
                    }
                }
            });
        }
        $scope.popupTank = function (customerId, tank, callback) {
            var modalInstance = $uibModal.open({
                animation: true,
                keyboard: false,
                backdrop: 'static',
                templateUrl: 'app/pages/tanks-linked/modals/tank.modal.html',
                controllerAs: 'popup',
                controller: function ($uibModalInstance) {

                    var popup = this;
                    var block_form_tank = blockUI.instances.get('form-tank');
                    popup.corruptedFields = [];
                    popup.tank = tank ? tank : {
                        owner_id: customerId,
                        title: '',
                        code: '',
                        address: '',
                        latitude: '',
                        longitude: '',
                        product_title: '',
                        product_volume: null,
                        volume: null
                    };
                    popup.tankValidator = {
                        isTitleValid: function (formData) {
                            var form = formData || popup.tank;
                            return !!form && form.title.length;
                        },
                        isProductTitleValid: function (formData) {
                            var form = formData || popup.tank;
                            return !!form && (form.product_title || '').length;
                        },
                        isAddressValid: function (formData) {
                            var form = formData || popup.tank;
                            return !!form && ((form.address || '').toString().length || ((form.latitude || '').toString().length && (form.longitude || '').toString().length));
                        },
                    }

                    function validateTank() {
                        var validationResult = {
                            isValid: true,
                            corruptedFields: []
                        };
                        for (var validatorName in popup.tankValidator) {
                            var isValid = popup.tankValidator[validatorName](popup.field);
                            if (!isValid) {
                                validationResult.corruptedFields.push(validatorName);
                                validationResult.isValid = false;
                            }
                        }
                        return validationResult;
                    }

                    popup.saveTank = function (form) {

                        var validationResult = validateTank();
                        popup.corruptedFields = validationResult.corruptedFields;
                        if (!validationResult.isValid) {
                            return;
                        }

                        console.log('popup.tank', popup.tank)
                        var tank = angular.copy(popup.tank);


                        tank.volume = parseFloat(tank.volume);
                        console.log('typeof tank.volume', typeof tank.volume)
                        if (typeof tank.volume !== 'number' || isNaN(tank.volume)) {
                            delete tank.volume;
                        }

                        tank.product_volume = parseFloat(tank.product_volume);
                        if (typeof tank.product_volume !== 'number' || isNaN(tank.product_volume)) {
                            delete tank.product_volume;
                        }

                        if (typeof tank.latitude === 'string') {
                            tank.latitude = tank.latitude.replace(',', '.');
                        }
                        if (typeof tank.longitude === 'string') {
                            tank.longitude = tank.longitude.replace(',', '.');
                        }
                        tank.latitude = parseFloat(tank.latitude);
                        tank.longitude = parseFloat(tank.longitude);
                        if (typeof tank.latitude !== 'number' || isNaN(tank.latitude)) {
                            delete tank.latitude;
                        }
                        if (typeof tank.longitude !== 'number' || isNaN(tank.longitude)) {
                            delete tank.longitude;
                        }
                        if (!tank.owner_external_id) {
                            delete tank.owner_external_id;
                        }
                        if (!tank.owner_email) {
                            delete tank.owner_email;
                        }
                        if (!tank.owner_phone) {
                            delete tank.owner_phone;
                        }
                        if (!tank.owner_name) {
                            delete tank.owner_name;
                        }

                        console.log('tank', tank)
                        var callbackTankForOwner = function (success, data) {
                            block_form_tank.stop();
                            if (success) {
                                if (callback) {
                                    callback(customerId);
                                }
                                NotifyService.Success('', false);
                                popup.closeModal();
                            }
                        }

                        block_form_tank.start();
                        if (!!tank.id) {
                            TanksService.UpdateTankForOwner(customerId, tank.id, tank, callbackTankForOwner)
                        } else {
                            TanksService.AddTankForOwner(customerId, tank, callbackTankForOwner)
                        }
                    }

                    popup.closeModal = function () {
                        $uibModalInstance.close();
                    };
                }
            });
        }

        $scope.pager_count = [10, 20, 50, 100, 200];

        $scope.getTableHeaderClass = function (row) {
            return {
                'sorting': !!row.sorting,
                'sorting_asc': !!row.sorting && $scope.params.sort === row.sorting && $scope.params.order === 'asc',
                'sorting_desc': !!row.sorting && $scope.params.sort === row.sorting && $scope.params.order === 'desc'
            }
        };


        $scope.onSortOrderChange = function (row) {
            if (!row.sorting) {
                return;
            }
            if ($scope.params.sort === row.sorting)
                $scope.params.order = $scope.params.order === "asc" ? "desc" : "asc";
            else
                $scope.params.order = "asc";

            $scope.params.sort = row.sorting;
        }

        $scope.pageChange = function () {
            getTanksLinked();
        };

        $scope.customersPageChange = function () {
            getCustomers();
        };

        /**
         *
         * @param count
         */
        $scope.onCountChange = function (count) {
            $scope.params.page = 1;
            $scope.params.count = count;
            getTanksLinked();
        };

        $scope.getCustomers = getCustomers;

        function getCustomers(selectedCustomerId) {
            block_tanks_linked_list.start();
            var getCustomersParams = angular.copy($scope.customerParams);

            CustomerService.AllTypeCustomers(getCustomersParams, function (success, data) {
                if (success) {
                    $scope.customers = angular.copy(data.data);
                    $scope.tanksLinkedSummary = angular.copy(data.summary);
                    $scope.customersSummary = angular.copy(data.summary);
                    if (selectedCustomerId) {
                        $scope.selectedCustomer = $scope.customers.find(function (customer) {
                            return customer.id === selectedCustomerId;
                        }) || null;
                    } else {
                        if (!getCustomersParams.search_text) {
                            $location.path(`/tanks-linked/create`).search({})
                        }
                        $scope.selectedCustomer = null;
                        $scope.customerTanks = [];
                    }
                }
                block_tanks_linked_list.stop();
            });
        }

        $scope.selectCustomer = function (customer) {
            var params = paramsToUrlQueryEncodeURIComponent({
                customerId: customer.id,
                phone: customer.phone,
                email: customer.email
            })
            $location.url(`${$location.$$path}?${params}`);
            $scope.selectedCustomer = customer;
            $scope.customerTanks = [];
            getCustomerTanks(customer.id);
        }

        $scope.getCustomerTanks = getCustomerTanks;

        function getCustomerTanks(customerId) {
            block_tanks_list.start();
            var params = {};
            TanksService.GetTanks(customerId || $scope.selectedCustomer.id, params, function (success, response) {
                if (success) {
                    $scope.customerTanks = response;
                }
                block_tanks_list.stop();
            })
        }

        $scope.popupLink = function (tank, callback) {
            var modalInstance = $uibModal.open({
                animation: true,
                keyboard: false,
                backdrop: 'static',
                templateUrl: 'app/pages/tanks-linked/modals/tank.links.modal.html',
                controllerAs: 'popup',
                controller: function ($uibModalInstance) {

                    var popup = this;
                    popup.tank = {};
                    popup.goodsList = [];
                    popup.goodsChoises = [];
                    var block_form_tank = blockUI.instances.get('form-tank');

                    function getLinkInfo() {
                        if (tank.linked) {
                            block_form_tank.start();
                            TanksService.GetTankLinked(tank.id, function (success, data) {
                                if (success) {
                                    popup.tank = angular.copy(data);
                                    getGoods();
                                } else {
                                    block_form_tank.stop();
                                }
                            });
                        } else {
                            popup.tank = tank;
                            block_form_tank.start();
                            getGoods();
                        }
                    }

                    function getGoods() {
                        EmbeddedService.GetGoods({
                            service_type: 'fuel',
                        }, function (success, data) {
                            if (success) {
                                popup.goodsList = angular.copy(data);

                                if (popup.tank.goods_code) {
                                    var productFromList = popup.goodsList.find(function (goods) {
                                        return goods.code == popup.tank.goods_code;
                                    })
                                    popup.product = productFromList ? productFromList : {code: popup.tank.goods_code};
                                }
                            }
                            block_form_tank.stop();
                        });
                    }

                    popup.onSelect = function (item) {
                        if (typeof item === 'string') {
                            popup.product = {
                                code: item
                            }
                        }
                    }

                    getLinkInfo();
                    popup.saveLink = function (form) {
                        if (form.product.$valid) {
                            var updateLinkCallback = function (success) {
                                if (success) {
                                    callback();
                                    NotifyService.Success('', false);
                                }
                                block_form_tank.stop();
                                popup.closeModal();
                            }
                            var linkParams = {
                                id: popup.tank.id,
                                owner_id: popup.tank.owner_id,
                                goods_code: popup.product.code
                            };
                            if (popup.tank.goods_code !== linkParams.goods_code) {
                                block_form_tank.start();
                                if (popup.tank.linked) {
                                    TanksService.UpdateTankLinked(linkParams.id, linkParams, updateLinkCallback)
                                } else {
                                    TanksService.AddTankLinked(linkParams, updateLinkCallback)
                                }
                            } else {
                                popup.closeModal();
                            }
                        } else {
                            form.product.$dirty = true;
                        }
                    }

                    popup.closeModal = function () {
                        $uibModalInstance.close();
                    };
                }
            });
        }

        $scope.$watch('customerParams.customer_type', function (newValue, oldValue) {
            if (newValue && newValue !== oldValue) {
                $scope.getCustomers();
                $scope.customerTanks = [];
            }
        }, true);
    }
})();
